import { Subject, Factor } from '@/plugins/api'
import alert from '@/plugins/alert'
import constant from '@/store/other/constant'
import { rangeRight } from 'lodash-es'

const defaultFactors = constant.defaultFactors

export default {
  namespaced: true,
  state: {
    subjects: [],
    subjectsData: [],
    subject: {},
    defaultFactors,
    itemsPerPage: 10,
    subjectSearch: {},
    loading: false,
    totalItems: 0
  },
  actions: {
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.subjectSearch) {
        const subjectSearch = {
          ...state.subjectSearch,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'gradeNumber:DESC'
        }
        const [subjectsData, totalItems] = await Promise.all([
          Subject.fetch(subjectSearch),
          Subject.count(subjectSearch)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            totalItems,
            subjectsData,
            itemsPerPage,
            subjectSearch
          })
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    },
    async fetchSubjects({ commit, state }, options) {
      state.loading = true
      const subjects = await Subject.fetch({ ...options, _sort: 'gradeNumber:DESC' })
      let sortedSubjects = []

      if (options.grade) {
        sortedSubjects = subjects.sort(
          (a, b) => (a.subjectGroup && a.subjectGroup.index) - (b.subjectGroup && b.subjectGroup.index)
        )
      } else if (!options.subjectGroup) {
        for (let index = 6; index <= 12; index++) {
          const subjectHasGradeList = subjects
            .filter(s => s.grade && s.grade.gradeNumber === index)
            .sort((a, b) => (a.subjectGroup && a.subjectGroup.index) - (b.subjectGroup && b.subjectGroup.index))

          sortedSubjects.unshift(...subjectHasGradeList)
        }

        const subjectNoGradeList = subjects.filter(s => !s.grade)
        sortedSubjects.push(...subjectNoGradeList)
      } else {
        sortedSubjects = subjects
      }
      commit('setSubjects', sortedSubjects)
      state.loading = false
    },
    async fetchSubject({ commit }, id) {
      try {
        commit('setSubject', await Subject.fetchOne(id))
      } catch (error) {
        alert.error(error)
      }
    },
    async createSubject({ commit }, data) {
      try {
        const factors = [
          ...defaultFactors.map(f => ({
            ...f,
            semesterType: 'semester-1'
          })),
          ...defaultFactors.map(f => ({
            ...f,
            semesterType: 'semester-2'
          }))
        ]
        const factorPromises = factors.map(async f => Factor.create(f))
        const factorRes = await Promise.all(factorPromises)
        const subject = await Subject.create({ ...data, factors: factorRes.map(f => f.id) })

        commit('createSubject', subject)
        return subject
      } catch (e) {
        alert.error(e)
      }
    },
    async removeSubject({ commit }, id) {
      try {
        await Subject.remove(id)
        commit('removeSubject', id)
        alert.success('Xóa thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async updateSubject({ commit }, { id, ...subject }) {
      try {
        const res = await Subject.update(id, subject)
        commit('updateSubject', { id, subject: res })
        alert.success('Cập nhật thành công!')
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setSubjects(state, subjects) {
      state.subjects = subjects
    },
    setSubject(state, subject) {
      state.subject = subject
    },
    updateSubject(state, { subject, id }) {
      state.subjects = state.subjects.map(g => {
        if (g.id === id) return subject
        else return g
      })
      state.subject = subject
    },
    createSubject(state, subject) {
      state.subjects = [subject, ...state.subjects]
    },
    removeSubject(state, id) {
      state.subjects = state.subjects.filter(subject => subject.id !== id)
    }
  },
  getters: {
    defaultFactors: state => state.defaultFactors
  }
}
